<template>
  <div class="progress-bar-container">
    <b-progress height="1rem" :max="getProgress.totalAmount" v-if="getProgress">
      <b-progress-bar :value="getProgress.loaded" variant="loaded"></b-progress-bar>
      <b-progress-bar :value="getProgress.available + getProgress.unknownBarcode" variant="unloaded"></b-progress-bar>
    </b-progress>
  </div>
</template>

<script>
  export default {
    name: 'progress-bar-cargo',
    props: ['cargo', 'progressOutgoing'],
    computed: {
      getProgress() {
        return this.progressOutgoing
      }
    }
  }
</script>

<style lang="scss" scoped>
.progress-bar-container {
  width: 100%;
}
  .progress {
    margin-bottom: -1px;
  }

  .progress {
    background: white;
  }

  .bg-loaded {
    background: #00b954 !important;
  }

  .bg-unloaded {
    background: #00c9ff !important
  }
</style>